// eslint-disable-next-line @nx/enforce-module-boundaries
import { m } from '@larvitu/shared/framer-motion/rsc';
import { MuiTheme } from '@larvitu/shared/mui/feature-theme-provider';
import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';

import { ImgBox, MuiSvgIcon, setColor, StyledBox } from './helper/CTAHelper';

import type { CallToActionButtonProps } from './@types/CTATypes';
import type { ThemeOptions } from '@mui/material';
import type { FC } from 'react';

// -------------------------------------
// Theme
// -------------------------------------

const CTATheme: ThemeOptions = {
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          padding: 0,
          backgroundColor: 'transparent',
          border: 'none',
          '&:hover': {
            backgroundColor: 'transparent',
            border: 'none',
          },
        },
      },
    },
  },
};

// -------------------------------------
// defaults
// -------------------------------------

// transitions
const defaultTransition = { type: 'ease-in-out', duration: 0.2 };

const rightArrowVariants = {
  hover: {
    scale: 0,
  },
};

// svg
const defaultSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" />
  </svg>
);

// -------------------------------------
// CTA Component
// -------------------------------------

export const CallToActionButton: FC<CallToActionButtonProps> = ({
  dimension = 3, // uses number and makes it em
  content,
  leftIcon = defaultSvg,
  rightIcon = defaultSvg,
  color,
  ...props
}) => {
  const buttonVariants = {
    initial: {
      x: `-${dimension}em`,
    },
    hover: {
      x: 0,
    },
  };

  return (
    <MuiTheme.Merge theme={CTATheme}>
      {/*<LoadingButton*/}
      {/*  {...props}*/}
      {/*  variant="contained"*/}
      {/*>*/}
      <Box
        component={m.div}
        display="flex"
        position="relative"
        initial="initial"
        whileHover="hover"
        bgcolor=""
        borderRadius="inherit"
      >
        <ImgBox
          dimension={`${dimension}em`}
          sx={(theme) => ({
            backgroundColor: setColor( theme, color ),
          })}
        >
          <MuiSvgIcon svg={leftIcon} />
        </ImgBox>

        <StyledBox
          component={m.div}
          transition={defaultTransition}
          variants={buttonVariants}
          position="relative"
          zIndex={1}
          px={`${dimension * 3 / 4}em`}
          sx={(theme) => ({
            backgroundColor: setColor( theme, color ),
          })}
        >
          {content}
        </StyledBox>

        <ImgBox
          variants={rightArrowVariants}
          transition={defaultTransition}
          position="absolute"
          right={0}
          dimension={`${dimension}em`}
          sx={(theme) => ({
            backgroundColor: setColor( theme, color ),
          })}
        >
          <MuiSvgIcon svg={rightIcon} />
        </ImgBox>
      </Box>
      {/*</LoadingButton>*/}
    </MuiTheme.Merge>
  );
};
